import PicklistMetadata from "../PicklistMetadata";

// Bounded picklist of ALL company Positions (display = Name, value = USID), sourced from the Position
// EC (t5/v1/positions), realm-scoped. Used by the "Add Shared Position" membership picker on the term
// Stewardship/Visibility tab — sharing a term grants visibility to positions beyond the user's own,
// so this lists every company position (unlike the memberships-only "Position" picklist).
class PositionSharedPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "PositionShared";
        this.bounded = true;
        this.enterpriseComponent = "Position";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        // Only shared-eligible positions: the term Visibility/Stewardship share applies to Data
        // Catalog positions, so restrict the picker to Positions whose Focus Area is "Data Catalog".
        // Consumed by PositionEnterpriseComponent.performQuery as an EQUAL QBE member (IDOC tag "FocusArea").
        this.searchSpecification = {"FocusArea": "Data Catalog"};
        this.sortSpecification = [{"SortAttribute": "Name", "Direction": "ASC"}];
        // Render the dropdown as an indented Position hierarchy with tree-line glyphs (parent -> children
        // by ParentUSID), rather than a flat A-Z list. Positions whose parent is filtered out (e.g. a
        // non-Data-Catalog parent) surface as roots; within each level, children keep the A-Z sort above.
        this.hierarchical = true;
        this.hierarchyParentField = "ParentUSID";
        // Append the position's primary user to each option: "Name (Primary User: <name>)".
        this.secondaryDisplayField = "PrimaryAccountUserName";
        this.secondaryDisplayLabel = "Primary User";
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default PositionSharedPicklistMetadata;
